import React, { useEffect, useState } from "react";
import { Row, Col, Button } from "reactstrap";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import TrueFocus from "pages/Ui/React-blits/TrueFocus";

const DeedDisplay = ({ data, type }) => {
  // console.log("deeddisplay:",data);
  // console.log("deedtype:",type)
  const [path, setPath] = useState("");
  // const[proType,setProType] = useState(false);

  // useEffect(()=>{
  //   setProType(type === 'Test-PurchaseContracts')
  // },[type])

  const docName = data?.file_data?.filename;
  // console.log(docName)

  const rawDocaiText = data?.file_data?.docai_text;
  const documentDataArray = Array.isArray(rawDocaiText) ? rawDocaiText : rawDocaiText ? [rawDocaiText] : [];

  // const documentDataArray = data?.file_data?.docai_text || [];
  const [openIndex, setOpenIndex] = useState(null); // To track which dropdown is open

  // console.log(documentDataArray)

  const toggleDropdown = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const Field = ({ label, value }) => (
    <div className="mb-3 pb-2 border-bottom">
      <div className="d-flex justify-content-between">
        <div className="w-50 text-right pe-3">{label}:</div>
        <div className="w-50 text-left">{value === "NA" ? "NA" : value}</div>
      </div>
    </div>
  );

  useEffect(() => {
    const storedData = localStorage.getItem("sucessUploadData");
    if (storedData) {
      const parsedData = JSON.parse(storedData);
      const selectedDoc = parsedData.find((doc) => doc.doc_name === docName);
      if (selectedDoc) {
        // Appended #view=FitH to fit the pdf width
        setPath(`${selectedDoc.doc_path}#view=FitH`);
      }
    }
  }, [docName]);

  const exportToExcel = () => {
    const excelData = documentDataArray.flatMap((doc, index) =>
      Object.entries(doc).map(([key, value]) => ({
        "Document No.": index + 1,
        Field: key,
        Value: value,
      }))
    );

    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Deed Data");

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, `${docName || "Deed_Data"}.xlsx`);
  };

  return (
    <Row className="vh-100">
      {/* Left Column - Document Details */}
      <Col md={5} className="p-3 overflow-y-auto" style={{ height: '100%' }}>
        <div className="mb-4 sticky-top bg-white">
          <h2 className="h4 mb-3">{docName}</h2>
          <Button color="primary" onClick={exportToExcel}>
            Export to Excel
          </Button>
        </div>

        {/* Accordion Dropdown for Multiple Records */}
        <div className="scroll-container" style={{ maxHeight: 'calc(100vh - 150px)', overflowY: 'auto' }}>
          {documentDataArray.map((doc, index) => (
            <div key={index} className="mb-3">
              <button
                className="btn btn-outline-primary w-100 text-left"
                onClick={() => toggleDropdown(index)}
              >
                Document {index + 1} {openIndex === index ? "▲" : "▼"}
              </button>
              <div className={`collapse ${openIndex === index ? "show" : ""}`}>
                <div className="border p-3 mt-2">
                  {Object.entries(doc)
                    .sort()
                    .map(([key, value]) => (
                      <Field key={key} label={key} value={value} />
                    ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </Col>

      {/* Right Column - PDF Viewer */}
      <Col md={7} className="bg-white border-start p-0" style={{ height: '100%' }}>
        <div
          className="d-flex align-items-center justify-content-center bg-light"
          style={{ 
            height: '100%',
            overflowY: 'auto'
          }}
        >
          <iframe
            src={path}
            width="100%"
            height="100%"
            style={{ border: "none" }}
          ></iframe>
        </div>
      </Col>
    </Row>
  );
};

export default DeedDisplay;
